<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex sm6 md4 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField v-model="language.name"
											:error="languageValidation.name"
											:label="'* '+$t('fields.name')"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField v-model="language.code"
											:error="languageValidation.code"
											:label="'* '+$t('fields.code')"></InputField>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import Language from "../models/Language";

export default {
	name: "Language",
	components: {CheckBox, InputField, Dropdown, Editor},
	data: function () {
		return {
			language: new Language({id: this.$route.params.id}),
			languageValidation: {
				id: '',
				name: '',
				code: '',
				additional_information: ''
			},
			initialLoad: false,
			changesHappened: false
		}
	},
	watch: {
		language: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			let success = true;

			if (this.language.name == '') {
				success = false;
				this.languageValidation.name = this.$t('alerts.fieldError');
			} else {
				this.languageValidation.name = '';
			}

			if (this.language.code == '') {
				success = false;
				this.languageValidation.code = this.$t('alerts.fieldError');
			} else {
				this.languageValidation.code = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.language.id != 0) {
					action = 'put';
					addition = '/' + vm.language.id;
				}
				this.$APICall(action, 'languages' + addition, this.language, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.language.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		let vm = this;
		if (this.language.id != 0) {
			this.$APICall('get', 'languages/' + this.language.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.languages'), href: '/#/languages', disabled: false},
						{text: vm.language.email, href: '/#/languages/' + vm.language.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					usableData.password_change = false;
					vm.language = usableData;
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.languages'), href: '/#/languages', disabled: false},
				{text: this.$t('modules.newLanguage'), href: '/#/languages/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
